export default function LocalFoodSystems() {
  return (
    <section
      data-testid="local-food-systems-section"
      className="relative bg-sand py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-5 md:sticky md:top-28">
            <div className="text-xs uppercase tracking-[0.3em] text-sage mb-6">
              Systems Thinking
            </div>
            <h2
              data-testid="local-systems-heading"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-charcoal"
            >
              Why local
              <span className="block italic text-sage">food systems matter.</span>
            </h2>

            <div className="mt-10 relative">
              <img
                src="https://customer-assets.emergentagent.com/job_country-gardens/artifacts/7qhikzy0_full%20box.jpg"
                alt="Freshly harvested produce — leafy greens, chillies and zucchini, abundant and tactile"
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
          </div>

          <div className="md:col-span-6 md:col-start-7 space-y-7 text-base md:text-lg leading-relaxed text-ink">
            <p>
              For decades, Australia's food systems have become increasingly
              dependent on long and centralised supply chains.
            </p>

            <p>
              Floods, road closures, fuel volatility and climate events continue
              to expose how vulnerable remote communities are to interruptions
              in food supply.
            </p>

            <p>
              Growing Country supports a complementary model focused on
              strengthening local food capability through{" "}
              <span className="text-charcoal font-medium">
                community gardens, seed systems, training, mobile horticultural
                support
              </span>{" "}
              and{" "}
              <span className="text-charcoal font-medium">
                regional food resilience networks
              </span>.
            </p>

            <p className="font-serif text-2xl md:text-3xl text-charcoal italic leading-snug border-l-2 border-sage pl-6 my-12">
              Food security is not simply about food availability.
              <span className="block mt-2 text-sage not-italic font-serif">
                It is about relationships, participation, local knowledge — and
                the ability of communities to adapt under pressure.
              </span>
            </p>

            <div className="pt-8 border-t border-stone-line/70 grid grid-cols-2 gap-y-6 gap-x-8">
              {[
                "Regional resilience",
                "Local food capability",
                "Resilience infrastructure",
                "Climate adaptation",
                "Local production networks",
                "Community capability",
              ].map((tag) => (
                <div
                  key={tag}
                  className="flex items-center gap-3 text-sm md:text-base text-charcoal"
                >
                  <span className="w-1.5 h-1.5 bg-sage shrink-0" aria-hidden />
                  <span>{tag}</span>
                </div>
              ))}
            </div>

            <p className="pt-4 text-charcoal font-medium">
              Strengthening Indigenous-led food resilience also contributes to
              Australia's broader national food security future.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
